import React from "react";
import PropTypes from "prop-types";
import styled from "styled-components";
import AnimateHeight from "react-animate-height";
import { color } from "src/styles/variables";

function Expandable({ duration = 200, isOpened = false, children, ...rest }) {
  return (
    children && (
      <AnimateHeight
        duration={duration}
        height={isOpened ? "auto" : 0}
        {...rest}
      >
        {children}
      </AnimateHeight>
    )
  );
}
Expandable.propTypes = {
  duration: PropTypes.number,
  isOpened: PropTypes.bool,
  children: PropTypes.any,
};

export default Expandable;

export function AnimatedExpandChevron({ isDown = true }) {
  return (
    <Chevron>
      <LeftChevronLine isDown={isDown} />
      <RightChevronLine isDown={isDown} />
    </Chevron>
  );
}
AnimatedExpandChevron.propTypes = {
  isDown: PropTypes.bool,
};

const chevronStyles = `
  height: 4px;
  border-radius: 20px;
  width: 15px;
  transition: transform .2s ease;
  background-color: ${color.grey};
  display: inline-block;
`;

const Chevron = styled.div`
  display: inline-block;
`;

const LeftChevronLine = styled.span`
  ${chevronStyles}
  transform: translate3d(3px, -3px, 0) ${({ isDown }) =>
    isDown ? "rotate(40deg)" : "rotate(-40deg)"};
`;

const RightChevronLine = styled.span`
  ${chevronStyles}
  transform: translate3d(-3px, -3px, 0) ${({ isDown }) =>
    isDown ? "rotate(-40deg)" : "rotate(40deg)"};
`;
